import { Injectable } from "@angular/core";
import { BehaviorSubject, forkJoin } from "rxjs";
import { KeyValuePair } from "../models/key-value-pair.model";
import { WorkSheet, utils, read } from "@e965/xlsx";
import { isEqual } from "lodash-es";

@Injectable({
  providedIn: "root",
})
export class FileService {
  private getSheetHeaders(sheet: WorkSheet): string[] {
    const range = utils.decode_range(sheet["!ref"]!);
    const headers: string[] = [];

    for (let col = range.s.c; col <= range.e.c; col++) {
      const cellAddress = utils.encode_cell({ r: 0, c: col });
      const cell = sheet[cellAddress];
      headers.push(cell ? cell.v : "");
    }

    return headers;
  }

  createDataFromExcelSheet<T>(files: File[], fileType: KeyValuePair[]) {
    const output: BehaviorSubject<T[]>[] = [];

    if (files && files.length > 0) {
      for (const file of Array.from(files)) {
        const output$ = new BehaviorSubject<T[]>([]);
        output.push(output$);
        const reader = new FileReader();
        reader.onload = (e: ProgressEvent<FileReader>) => {
          const abuf = e.target?.result;
          const wb = read(abuf, { type: "array" });

          const sheetName = wb.SheetNames ? wb.SheetNames[0] : null;
          const worksheet = sheetName ? wb.Sheets[sheetName] : null;

          if (worksheet) {
            const uploadedHeaders = this.getSheetHeaders(worksheet);
            const requiredHeaders = fileType.map((type) => type.value);

            if (!isEqual(uploadedHeaders, requiredHeaders)) {
              output$.next([]);
              output$.complete();
              return;
            }

            const excelData = utils.sheet_to_json(worksheet);
            if (excelData && excelData.length > 0) {
              const outputData = excelData.map((data: unknown) => {
                const newData = {} as T;

                fileType.forEach((keyValuePair: KeyValuePair) => {
                  newData[keyValuePair.key as keyof T] =
                    (data as object[keyof object])[keyValuePair.value as keyof object] ?? "";
                });

                return newData;
              });
              output$.next(outputData);
              output$.complete();
            } else {
              output$.complete();
            }
          }
        };
        reader.readAsArrayBuffer(file);
      }
    }

    return forkJoin(output);
  }
}
